import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetCompanySetting, getStoreInformation } from '../../services/companyService';
import Slider from 'react-slick';

const ProfileStore = ({ storeId, store }) => {
    const [config, setConfig] = useState(null);
    const [banners, setBanner] = useState([]);
    const [description, setDescription] = useState('');

    useEffect(() => {
        // console.log("storeId profile", storeId.storeId)
        // if (!storeId.storeId) return;
        if (!store) return;

        const load = async () => {
            try {
                // const data = await getStoreInformation(storeId.storeId);
                setConfig(store);

                if (store?.contentBanner) {
                    if (store?.contentBanner !== 'null') {
                        setBanner(JSON.parse(store.contentBanner));
                    }
                }
                if (store?.description) {
                    setDescription(store.description);
                }
            } catch (e) {
                console.error('Failed to load store info', e);
            }
        };

        load();
    }, [storeId.storeId, store]);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        adaptiveHeight: true
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        // responsive: [
        //     {
        //         breakpoint: 1399,
        //         settings: {
        //             slidesToShow: 3,
        //         },
        //     },
        //     {
        //         breakpoint: 1199,
        //         settings: {
        //             slidesToShow: 2,
        //         },
        //     },
        //     {
        //         breakpoint: 575,
        //         settings: {
        //             slidesToShow: 1,
        //         },
        //     },

        // ],
    };

    return (
        <section className="ProfileStore">
            <div className="container">
                {/* <div className="profileBg" style={{backgroundImage:"url('assets/images/profile_temp/fa6754abe8468192cb6c4ff8199c1e3e08cea86a.jpg')"}}>

            </div> */}

                {banners.length > 0 && (
                    <Slider {...settings}>
                        {banners.map((item, index) => (
                            <div key={index} style={{ minHeight: '100%' }}>
                                <div className="profileBg" style={{ backgroundImage: `url(${item.previewUrl}?width=1440)` }}></div>
                            </div>
                        ))}
                    </Slider>
                )}

                <div className="profileLongDesc mt-20" style={{ whiteSpace: 'pre-line' }}>
                    {description}
                    {/* <p>Selamat datang di ✨[Nama Toko Kamu]✨ — tempatnya produk berkualitas dengan harga bersahabat 💕 </p> 
                <p>Kami menyediakan berbagai pilihan [jenis produk, misalnya: fashion kekinian, aksesoris lucu, skincare original, atau perlengkapan rumah tangga modern] untuk memenuhi kebutuhan kamu setiap hari!</p>
                <br />
                <p>Kenapa belanja di kami?</p>
                <br />
                <p>✅ Produk 100% original & berkualitas</p> 
                <p>✅ Pengiriman cepat & aman</p>
                <p>✅ Pelayanan ramah dan fast response</p> 
                <p>✅ Garansi tukar jika barang cacat</p>
                <br />
                <p>Jam Operasional Toko:</p>
                <ul style={{listStyleType:"disc", paddingLeft:"1.5em"}}>
                    <li>Senin – Jumat : 09.00 – 21.00 WIB</li>
                    <li>Sabtu : 09.00 – 18.00 WIB</li>
                    <li>Minggu : Tutup (tetap bisa order, akan diproses keesokan harinya)</li>
                </ul>
                <br />
                <p>
                    Alamat Toko (Offline Store):
                </p>
                <p>
Jl. Mawar No. 12, Kel. Sukamaju, Kec. Sukasari, Bandung, Jawa Barat 40123
                </p>
                <br />
                <p>Hubungi Kami:</p>
                <p>WhatsApp: wa.me/6281234567890</p>
                <p>Instagram: instagram.com/namatoko</p>
                <p>TikTok: tiktok.com/@namatoko</p>
                <p>Shopee: shopee.co.id/namatoko</p> */}
                </div>
            </div>
        </section>
    );
};

export default ProfileStore;
